<template>
    <div>
        <div class="wrapper">
            <div class="animated fadeIn">
                <resource-index header="Aanvragen" endpoint="requests" show-route="requests.view"></resource-index>
            </div>
        </div>
    </div>
</template>

<script>
    import ResourceIndex from '../../components/ResourceIndex';

    export default {
        name: 'requests',
        components: {ResourceIndex},
    }
</script>
